<template>
    <!-- begin panel -->
    <panel :title="nuevo ? 'Registrar Nueva Comision de Equipo':'Editar Comision de Equipo'" panelClass="panel-with-tabs"
        variant="default" ref="header" noButton="false">
        <form action="/" method="POST">
            <fieldset>
                <div class="row">
                    <div class=" col-xl-4 col-lg-4">
                        <div class="form-group">
                            <label>Nombre Comisión</label>
                            <input type="text" data-vv-name="nombre" v-validate="'required'" v-model="comisionEquipo.comision" placeholder="Ingrese el nombre"
                                class="form-control">
                                 <error :attribute_name="'nombre'" :errors_form="errors" />
                        </div>
                    </div>
                
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Monto</label>
                            <input type="text" data-vv-name="monto" v-validate="'required'" v-model="comisionEquipo.monto" placeholder="Ingrese el monto"
                                class="form-control">
                                 <error :attribute_name="'monto'" :errors_form="errors" />
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class=" offset-xl-10 offset-lg-8  offset-md-8 col-xl-1  col-lg-2  col-md-2 text-center">
                        <button type="button" @click="$emit('cancelar')" class="btn btn-default btn-sm btn-circle  btn-block"> <i
                                class="fa fa-times "></i> CANCELAR </button>
                    </div>
                    <div class="  col-xl-1 col-lg-2 col-md-2  text-center">
                        <button v-if="nuevo" type="button" @click="validarFormulario('guardar')"
                            class="btn btn-primary btn-sm  btn-block"> <i class="fa fa-save "></i> GUARDAR </button>
                        <button v-else type="button" @click="validarFormulario('actualizar')"
                            class="btn btn-info btn-sm btn-circle  btn-block"> <i class="fa fa-save "></i> EDITAR </button>
                    </div>

                </div>

            </fieldset>
        </form>

    </panel>
    <!-- end panel -->
</template>

<script>
    import error from '../Error'

    export default {
        name: 'ComisionEquipoComponent',
        props: ['registro', 'nuevo'],
        components: {
            error

            // vueSelect
        },
        data() {
            return {
                data: [],
                iniciar_autocompletado: false,
                comisionEquipo: {
                    comision: "",
                    monto: "",
                },
            }
        },
        created() {
            setTimeout(() => {
                this.iniciar_autocompletado = true;
            }, 100);

        },
        mounted() {
            if (!this.nuevo) {
                this.comisionEquipo = {
                    ...this.registro
                };
            } else {
                this.limpiar();
            }
            this.data = this.$store.state.dataTipoAfectacion;
        },
        methods: {
            validarFormulario(tipo){

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if(tipo=='guardar'){
                            this.$emit('guardar',this.comisionEquipo);
                        }else{
                            this.$emit('actualizar',this.comisionEquipo);
                            setTimeout(() => {
                                this.$emit('cancelar');
                            }, 250);
                            
                        }
                        return;
                    }
                });
            },
            opcionSeleccionada(seleccion) {
                this.comisionEquipo.emisor_id = seleccion.id;
            },
            limpiar() {
                this.comisionEquipo.comisionEquipo = "";
                this.comisionEquipo.emisor_id = "";
                this.comisionEquipo.emisor = "";
                this.comisionEquipo.estado = "1";
            },

        }
    }
</script>